var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":true,"opacity":0},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('system-notice-host')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }